import { render, staticRenderFns } from "./SalabamVacanzeVadobay.vue?vue&type=template&id=7b9ff828&scoped=true"
import script from "./SalabamVacanzeVadobay.vue?vue&type=script&lang=js"
export * from "./SalabamVacanzeVadobay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9ff828",
  null
  
)

export default component.exports